import { Building2, Globe, Tag } from "lucide-react";

interface InheritedOrgCardProps {
  company: {
    id: string;
    name: string;
    website?: string | null;
    industry?: string | null;
  } | null;
}

export function InheritedOrgCard({ company }: InheritedOrgCardProps) {
  if (!company) return null;

  return (
    <div className="rounded-lg border border-success/40 bg-success/5 p-3 space-y-1">
      <div className="flex items-center gap-1.5 text-2xs font-medium text-success uppercase tracking-wide">
        <Building2 className="h-3 w-3" />
        Organização herdada do lead
      </div>
      <div className="flex items-center gap-2">
        <div className="h-7 w-7 rounded-md bg-success/10 flex items-center justify-center text-success font-semibold text-xs">
          {company.name.charAt(0).toUpperCase()}
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium truncate">{company.name}</p>
          <div className="flex items-center gap-3 text-2xs text-muted-foreground">
            {company.website && (
              <span className="flex items-center gap-1 truncate">
                <Globe className="h-3 w-3 flex-shrink-0" />
                {company.website}
              </span>
            )}
            {company.industry && (
              <span className="flex items-center gap-1">
                <Tag className="h-3 w-3 flex-shrink-0" />
                {company.industry}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
